import { createSelector } from 'reselect';

import * as reducer from './categories.reducer';
import { AppState } from '../state';

export const getState = (state: AppState) => state.categories;

export const createCategoriesLoading = createSelector(getState, reducer.createCategoriesLoading);
export const createCategoriesData = createSelector(getState, reducer.createCategoriesData);
export const createCategoriesFailData = createSelector(getState, reducer.createCategoriesFailData);

export const getCategoriesListLoading = createSelector(getState, reducer.getCategoriesListLoading);
export const getCategoriesListData = createSelector(getState, reducer.getCategoriesListData);
export const getCategoriesListFailData = createSelector(getState, reducer.getCategoriesListFailData);

export const getCategoriesItemLoading = createSelector(getState, reducer.getCategoriesItemLoading);
export const getCategoriesItemData = createSelector(getState, reducer.getCategoriesItemData);
export const getCategoriesItemFailData = createSelector(getState, reducer.getCategoriesItemFailData);

export const updateCategoriesItemLoading = createSelector(getState, reducer.updateCategoriesItemLoading);
export const updateCategoriesItemData = createSelector(getState, reducer.updateCategoriesItemData);
export const updateCategoriesItemFailData = createSelector(getState, reducer.updateCategoriesItemFailData);

export const deleteCategoriesItemLoading = createSelector(getState, reducer.deleteCategoriesItemLoading);
export const deleteCategoriesItemData = createSelector(getState, reducer.deleteCategoriesItemData);
export const deleteCategoriesItemFailData = createSelector(getState, reducer.deleteCategoriesItemFailData);

export const createSliderItemLoading = createSelector(getState, reducer.createSliderItemLoading);
export const createSliderItemData = createSelector(getState, reducer.createSliderItemData);
export const createSliderItemFailData = createSelector(getState, reducer.createSliderItemFailData);

export const getSliderItemLoading = createSelector(getState, reducer.getSliderItemLoading);
export const getSliderItemData = createSelector(getState, reducer.getSliderItemData);
export const getSliderItemFailData = createSelector(getState, reducer.getSliderItemFailData);

export const getSliderListLoading = createSelector(getState, reducer.getSliderListLoading);
export const getSliderListData = createSelector(getState, reducer.getSliderListData);
export const getSliderListFailData = createSelector(getState, reducer.getSliderListFailData);

export const removeSliderItemLoading = createSelector(getState, reducer.removeSliderItemLoading);
export const removeSliderItemData = createSelector(getState, reducer.removeSliderItemData);
export const removeSliderItemFailData = createSelector(getState, reducer.removeSliderItemFailData);

export const updateSliderItemLoading = createSelector(getState, reducer.updateSliderItemLoading);
export const updateSliderItemData = createSelector(getState, reducer.updateSliderItemData);
export const updateSliderItemFailData = createSelector(getState, reducer.updateSliderItemFailData);

export const createPdfItemLoading = createSelector(getState, reducer.createPdfItemLoading);
export const createPdfItemData = createSelector(getState, reducer.createPdfItemData);
export const createPdfItemFailData = createSelector(getState, reducer.createPdfItemFailData);

export const deletePdfItemLoading = createSelector(getState, reducer.deletePdfItemLoading);
export const deletePdfItemData = createSelector(getState, reducer.deletePdfItemData);
export const deletePdfItemFailData = createSelector(getState, reducer.deletePdfItemFailData);

export const updatePdfItemLoading = createSelector(getState, reducer.updatePdfItemLoading);
export const updatePdfItemData = createSelector(getState, reducer.updatePdfItemData);
export const updatePdfItemFailData = createSelector(getState, reducer.updatePdfItemFailData);

export const getPdfItemLoading = createSelector(getState, reducer.getPdfItemLoading);
export const getPdfItemData = createSelector(getState, reducer.getPdfItemData);
export const getPdfItemFailData = createSelector(getState, reducer.getPdfItemFailData);

export const getPdfListLoading = createSelector(getState, reducer.getPdfListLoading);
export const getPdfListData = createSelector(getState, reducer.getPdfListData);
export const getPdfListFailData = createSelector(getState, reducer.getPdfListFailData);
export const getPdfListCount = createSelector(getState, reducer.getPdfListCount);

export const createSliderLoading = createSelector(getState, reducer.createSliderLoading);
export const createSliderData = createSelector(getState, reducer.createSliderData);
export const createSliderFailData = createSelector(getState, reducer.createSliderFailData);

export const updateSliderLoading = createSelector(getState, reducer.updateSliderLoading);
export const updateSliderData = createSelector(getState, reducer.updateSliderData);
export const updateSliderFailData = createSelector(getState, reducer.updateSliderFailData);

export const removeSliderLoading = createSelector(getState, reducer.removeSliderLoading);
export const removeSliderData = createSelector(getState, reducer.removeSliderData);
export const removeSliderFailData = createSelector(getState, reducer.removeSliderFailData);

export const getSliderLoading = createSelector(getState, reducer.getSliderLoading);
export const getSliderData = createSelector(getState, reducer.getSliderData);
export const getSliderFailData = createSelector(getState, reducer.getSliderFailData);

export const getSlidersLoading = createSelector(getState, reducer.getSlidersLoading);
export const getSlidersData = createSelector(getState, reducer.getSlidersData);
export const getSlidersFailData = createSelector(getState, reducer.getSlidersFailData);
